/*------------------------------------------------------------------------------
   About      : Shared heading and label styling for the NBI Insights forms
                (epic DA-697)

                The mockups render every sub-heading in grey; in the product they
                are the structure of a long authoring form, so they read as
                primary text. These constants keep that one decision in one
                place rather than repeating a colour literal on two dozen
                `Typography` calls.

                `FIELD_LABEL_SX` deliberately excludes `.Mui-focused` and
                `.Mui-error`: the focused label is the primary colour and the
                invalid one is red, and both are meaningful state that a blanket
                override would erase.

   Copyright (c) 2026 Bidgely. All rights reserved.
------------------------------------------------------------------------------*/
import { SxProps, Theme } from '@mui/material'

/** Panel heading — "TECHNICAL IDENTIFICATION", "ADVANCED: TEMPLATE CRITERIA". */
export const SECTION_HEADING_SX : SxProps<Theme> = {
  fontWeight    : 600,
  letterSpacing : '0.5px',
  color         : 'text.primary',
}

/** Sub-heading inside a panel — "CURRENTLY TAGGED", "GENERATED EXPRESSION PREVIEW". */
export const SUB_HEADING_SX : SxProps<Theme> = {
  fontWeight    : 600,
  letterSpacing : '0.5px',
  color         : 'text.primary',
  display       : 'block',
}

/** Applied to a TextField so its resting label is primary text, not grey. */
export const FIELD_LABEL_SX : SxProps<Theme> = {
  '& .MuiInputLabel-root:not(.Mui-focused):not(.Mui-error)' : { color : 'text.primary' },
}
